import './style.scss';

export function team_block() {
  const block = document.querySelector('.team_block');
  if (!block) return;
  
}
